export default {
    farm: {
        farmerId: "ID Petani",
        farmAddress: "Alamat Lokasi Peternakan",
        farmID: "ID Peternakan",
        farmIdPlaceHolder: "Masukkan ID Peternakan",
        onTheFarm: "Di Peternakan",
        userRoles: "Peran Pengguna",
        adduser: "Tambah Pengguna",
        addAuser: "Tambah Pengguna",
        uploadUsers: "Unggah Pengguna",
        addNewUser: "Tambah Pengguna Baru",
        selectDept: "Pilih Departemen",
        selectRole: "Pilih Peran",
        editUser: "Edit Pengguna",
        totalFarms: "Total Peternakan",
        NoAnimalsRegisteredForthisFarm:
          "Tidak ada hewan yang terdaftar untuk peternakan ini",
        farmsPerPage: "Peternakan per Halaman",
        regularFarms: "Peternakan Reguler",
        farmRegisteredProducts: "Produk Terdaftar Peternakan",
        searchByFarmNameAndId: "Cari berdasarkan Nama Peternakan dan ID",
        loadingProductsPleaseWait: "Memuat Produk... Mohon tunggu",
        farmName: "Nama Peternakan",
        nameOfTheFarm: "Nama Peternakan",
        farmLocation: "Lokasi Peternakan",
        productName: "Nama Produk",
        stockStatus: "Status Stok",
        inStock: "Tersedia",
        searchByProductName: "Cari Berdasarkan Nama Produk",
        productCategory: "Kategori Produk",
        products: "Produk",
        farms: "Peternakan",
        zones: "Zona",
        registerAfarm: "Daftarkan Peternakan",
        govtRegistry: "Registrasi Pemerintah",
        cooperativeId: "ID Koperasi/Uni",
        cooperativeName: "Nama Koperasi/Uni",
        farmType: "Tipe Peternakan",
        contractMating: "Pembiakan Kontrak",
        customization: "Penyesuaian",
        recordsPerpage: "Rekaman per Halaman",
        restoreDefault: "Pulihkan Default",
        apply: "Terapkan",
        CommunityName: "Nama Komunitas",
        corporateName: "Nama Perusahaan",
        corporateRegistrationNum: "Nomor Registrasi Perusahaan",
        communityName: "Nama Komunitas",
        searchState:
          "Cari berdasarkan ID Peternakan, Registrasi Pemerintah, ID Koperasi, Tipe Peternakan, Pembiakan Kontrak",
        farmOwner: "Pemilik Peternakan",
        govRegistrationNo: "Nomor Registrasi Pemerintah",
        farmInformation: "Informasi Peternakan",
        ownershipType: "Tipe Kepemilikan",
        farmLicenseInformation: "Informasi Lisensi Peternakan",
        licenseNumber: "Nomor Lisensi",
        licenseExpiryDate: "Tanggal Kadaluarsa Lisensi",
        regulatorName: "Nama Regulator",
        regulatorRepresentativeName: "Nama Perwakilan Regulator",
        farmLocationSize: "Lokasi & Ukuran Peternakan",
        productionSystem: "Sistem Pertanian",
        productionSystemNew: "Sistem Produksi",
        goals: "Tujuan",
        country: "Negara",
        state: "Provinsi",
        city: "Desa/Kota",
        gpsLocation: "Lokasi GPS",
        latitude: "Lintang",
        longitude: "Bujur",
        farmNumber: "Nomor Peternakan",
        postal: "Kode Pos",
        houseNumber: "Nomor Rumah",
        farmRegistration: "Registrasi Peternakan",
        cancel: "Batal",
        register: "Daftar",
        ok: "OK",
        totalFarmSize: "Total Ukuran Peternakan",
        farmGeographicLocation: "Lokasi Geografis Peternakan",
        perimeterPointLongitude: "Bujur Titik Perimeter",
        perimeterPointLatitude: "Lintang Titik Perimeter",
        perimeterPointLabel: "Label Titik Perimeter",
        perimeterLength: "Panjang Perimeter",
        farmLatitude: "Lintang Peternakan",
        farmLongitude: "Bujur Peternakan",
        editFarm: "Edit Peternakan",
        update: "Perbarui",
        editAfarm: "Edit Peternakan",
        nextFarm: "Peternakan Berikutnya",
        nameoftheFarm: "Nama Peternakan",
        addNewLocation: "Tambah Lokasi Baru",
        registerAProduct: "Daftarkan Produk",
        farmProducts: "Produk Peternakan",
        calf: "Anak Sapi",
        steer: "Sapi Jantan",
        heifer: "Sapi Betina",
        sire: "Sapi Pejantan",
        dam: "Sapi Induk",
        registerAnAnimal: "Daftarkan Hewan",
        farmAnimals: "Hewan Peternakan",
        farm_type: "Tipe Peternakan",
        farm_Owner: "Pemilik Peternakan",
        dateOfRegistration: "Tanggal Pendaftaran",
        dataIsNotAvailableForThisFarm: "Data Tidak Tersedia untuk Peternakan Ini",
        registerNewProduct: "Daftarkan Produk Baru",
        information: "Informasi",
        licenseInfo: "Info Lisensi",
        locationInfo: "Info Lokasi",
        geoLocation: "Lokasi Geografis",
        perimeterLengthState: "Panjang Perimeter Peternakan (Panjang Pagar)",
        totalFarmSizeState: "Ukuran Peternakan",
        productionSystemState: "Sistem Produksi yang Digunakan di Peternakan",
        contractMatingState:
          "Kode Program Pembiakan Kontrak yang Diikuti Peternakan",
        ownershipTypeState: "Tipe Kepemilikan",
        regulatorRepresentativeNameState:
          "Nama Perwakilan Regulator yang Menerbitkan Lisensi",
        regulatorNameState: "Nama Regulator yang Menerbitkan Lisensi",
        licenseExpiryDateState: "Tanggal Kadaluwarsa Lisensi Saat Ini",
        licenseNumberState: "Nomor Lisensi yang Dikeluarkan oleh Regulator",
        plotNumberState: "Nomor Rumah Peternakan",
        plotNumber: "Nomor Peternakan",
        streetStatement: "Nama Jalan Peternakan",
        cityStatement: "Kota Tempat Peternakan Berlokasi",
        farmLocationAddressInfo:
          "Tempat Utama Peternakan Melakukan Aktivitas Pertanian",
        provinceStateInfo:
          "Pembagian Administratif Utama di Negara atau Kekaisaran",
        cityInfo:
          "Pemukiman Manusia Terkonsentrasi atau Komunitas dan Bangunan Terkait, Lebih Besar dari Pemukiman Kecil dan Lebih Kecil dari Kota, Terletak di Daerah Pedesaan",
        streetNumberInfo: "Nomor Jalan",
        totalFarmSizeInfo: "Ukuran Total Peternakan",
        areaUOMInfo:
          "Unit Pengukuran untuk Ukuran Peternakan (misalnya, Hektar, Acre, dll.)",
        perimeterLengthInfo: "Total Panjang Perimeter Peternakan",
        permiterUOMInfo:
          "Unit Pengukuran untuk Perimeter Peternakan (misalnya, Sentimeter, Meter, dll.)",
        stateStatement: "Wilayah Negara Tempat Peternakan Berlokasi",
        countryState: "Negara Tempat Peternakan Berlokasi",
        farmStateInfo: "Alamat Lokasi Peternakan",
        perimeterPointLongitudeState: "Garis Bujur Satu Titik di Peternakan",
        perimeterPointLatitudeState: "Garis Lintang Satu Titik di Peternakan",
        perimeterPointLabelState: "Label Titik",
        farmLongitudeState: "Garis Bujur Peternakan",
        farmLatitudeState: "Garis Lintang Peternakan",
        deleteFarm: "Hapus Peternakan",
        farmNameH: "Nama Peternakan",
        farmTypeH: "Tipe Peternakan yang Melakukan Berbagai Aktivitas",
        farmOwnerH:
          "Nama Pemilik Peternakan (Auto-generate Nama Petani Memasukkan Info)",
        ownershipTypeH:
          "Jenis Petani yang Memiliki/Mengontrol Tanah yang Mereka Tanami dan Mereka yang Tidak",
        govtRegNumbH: "Nomor Registrasi Peternakan yang Ditetapkan oleh Regulator",
        contractMatingH: "Kode Program Pembiakan Kontrak yang Diikuti Peternakan",
        productionSystemH: "Sistem Produksi yang Digunakan di Peternakan",
        cooperativeIDH: "ID dari Koperasi yang Menjadi Anggota Peternakan",
        licenseNumberH:
          "Nomor Identifikasi pada Lisensi yang Dikeluarkan oleh Regulator yang Mengidentifikasikannya dengan Pemilik",
        licenseExpiryDateH: "Tanggal Kadaluwarsa Lisensi Saat Ini",
        regularNameH: "Nama Regulator yang Menerbitkan Lisensi",
        regularRepName:
          "Nama Orang yang Mewakili Regulator yang Menerbitkan Lisensi",
        countryH: "Negara Tempat Peternakan Berlokasi",
        stateH: "Wilayah Negara Tempat Peternakan Berlokasi",
        cityH: "Kota Tempat Peternakan Berlokasi",
        streetH: "Nama Jalan Peternakan",
        houseNumberH: "Nomor Rumah Peternakan",
        totalFarmSizeH:
          "Ukuran Peternakan adalah Jumlah Lahan yang Saat Ini Ditanami oleh Peternakan Termasuk Lahan yang Sedang Fallow tetapi Tidak Termasuk Lahan di Bawah Vegetasi Alami, Pohon atau Padang Rumput",
        farmLatitudeH:
          "Pengukuran Jarak ke Utara atau Selatan Khatulistiwa, Diukur dengan 180 Garis Imajiner yang Membentuk Lingkaran di Sekitar Bumi Timur-Barat, Paralel dengan Khatulistiwa",
        farmLongitudeH: "Pengukuran Jarak ke Timur atau Barat dari Meridian Utama",
        perimeterLengthH: "Panjang Perimeter Peternakan (Panjang Pagar)",
        perimeterPointLabelH:
          "Label Titik untuk Mendeskripsikan Perimeter Peternakan dan Segmen Apa pun di Dalam Peternakan",
        perimeterPointLatH: "Garis Lintang Satu Titik di Peternakan",
        perimeterPointLongH: "Garis Bujur satu titik di peternakan",
        street: "Jalan",
        registration: {
          regulatorName: "Nama regulator yang mengeluarkan lisensi",
          perimeterPointLabel:
            "Label titik. Menggunakan tiga parameter (lintang, bujur, dan label) kita mendeskripsikan sekeliling peternakan dan segmen di dalamnya.",
          perimeterPointLatitude: "Lintang titik sekeliling",
          perimeterPointLongitude: "Bujur titik sekeliling",
          farmID: "Nomor Identifikasi diberikan kepada peternakan ternak",
          farmName: "Nama yang diberikan kepada peternakan ternak",
          CommunityName:
            "Nama yang diberikan kepada kelompok orang dengan karakteristik atau minat bersama tinggal bersama dalam masyarakat yang lebih besar",
          farmType:
            "Tipe peternakan dapat diklasifikasikan (dikelompokkan) menurut ternak yang dibesarkan dan bagaimana cara dibesarkan",
          farmOwner:
            "Setiap orang yang memiliki atau mengendalikan operasi peternakan",
          ownershipType:
            "Jenis petani yang memiliki/mengontrol peternakan dan mereka yang tidak",
          govtRegistrationNumber:
            "Nomor yang diberikan oleh organisasi pemerintah di mana peternakan terdaftar",
          licenseNumber: "Nomor lisensi yang dikeluarkan oleh regulator",
          licenseExpiryDate: "Tanggal lisensi tidak berlaku lagi untuk diakui",
          regulatorRepresentativeName: "Nama Perwakilan Regulator",
        },
        addFarm: "Tambahkan Peternakan",
        importFarmsInBulk: "Impor Peternakan Massal",
        importFarms: "Impor Peternakan",
        importingNote:
          "File yang diunggah sedang diproses.\nJangan klik batal, tutup, atau refresh halaman ini untuk menghindari gangguan.",
        bulkImportNote:
          "Unduh dan gunakan template di bawah untuk impor massal peternakan.",
    
        importantNote: "Catatan Penting",
        selectFileToUpload: "Pilih file untuk mengunggah data",  
        importantNoteDetail: "Harap gunakan template yang disediakan di atas untuk unggahan massal. Format lain akan mengakibatkan kegagalan.",
        importCompleted: "Impor Selesai",
        farmerFirstName: "Nama Depan Petani",
        farmerMiddleName: "Nama Tengah Petani",
        farmerLastName: "Nama Belakang Petani",
        iAmNotFarmer: "Saya bukan petani",
        certifications: "Sertifikasi",
        productionType: "Tipe Produksi",
        deleted: "Peternakan berhasil dihapus.",
        notDeleted: "Peternakan tidak berhasil dihapus.",
        farmTitleDocument: "Dokumen Judul Peternakan",
        dropHere: "atau seret dan lepas di sini",
        technicianName: "Nama Teknisi",
    
        farmRegistrationId: "ID Registrasi Peternakan",
        farmerRegistrationId: "ID Registrasi Petani",
        farmId: "ID Peternakan",
        farmerName: "Nama Petani",
        farmOwnershipType: "Tipe Kepemilikan Petani",
        farmGoals: "Tujuan Peternakan",
        farmCertifications: "Sertifikasi Peternakan",
        farmInfo: "Informasi Peternakan",
        provinceState: "Provinsi/Negara Bagian",
        streetNumber: "Nomor Jalan",
        addGeofenceForThisFarm: "Tambahkan geofence untuk peternakan ini",
        pleaseClickToChooseLocation: "Klik untuk memilih lokasi",
        address: "Alamat",
        geographicLocation: "Lokasi Geografis",
        searchLocation: "Cari Lokasi",
        pleaseChooseOneOfTheOption: "Silakan pilih salah satu opsi",
        useGeoFencingFeature: "Gunakan fitur geofencing",
        uploadShapeFile: "Unggah file bentuk",
        uploadGeofence: "Unggah Geofence",
        upload: "Unggah",
        reports: "Laporan",
        avocado: "Alpukat",
        avocadoTrees: "Pohon Alpukat",
        addNewFarmLocation: "Tambahkan Lokasi Peternakan Baru",
        farmLocationAddress: "Alamat Lokasi Peternakan",
        useGeofenceTool: "Gunakan alat geofencing",
        geofenceIsRequiredForSatelliteReport:
          "Catatan: Geofence diperlukan untuk Laporan Satelit",
        enterHere: "Masukkan di sini",
        primaryLocation: "Lokasi Utama",
        secondaryLocation: "Lokasi Sekunder",
        locationAndSize: "Lokasi dan Ukuran",
        addNewZone: "Tambahkan Zona Baru",
        noZoneMessage: "Belum ada zona yang terdaftar.",
        noZoneRequest:
          "Klik Tambahkan Zona Baru untuk membuat Zona untuk Peternakan ini.",
        locationZone: "Zona Lokasi",
        editFarmLocation: "Edit Lokasi Peternakan",
        addZone: "Tambahkan Zona",
        nameOfTheZone: "Nama Zona",
        zoneDetails: "Detail Zona",
        perimeter: "Perimeter",
        areaUnit: "Unit Luas",
        area: "Luas",
        zoneName: "Nama Zona",
    
        farmGeofence: "Geofence Peternakan",
        circularGeofence: "Geofence Lingkaran",
        polygonGeofence: "Geofence Poligon",
        
    
        actions: "Tindakan",
        editZone: "Edit Zona",
        numberOfGroups: "Jumlah Kelompok",
        numberOfTrees: "Jumlah Pohon",
        group: "Grup",
        groupName: "Nama Grup",
        numberOfAnimals: "Jumlah Hewan",
        status: "Status",
        primaryGeofence: "Geofence Utama",
        walkAndMeasure: "Jalan dan Ukur",
        clearGeofence: "Bersihkan Geofence",
        deleteSelectedVertex: "Hapus Titik Terpilih",
        basicInformation: "Informasi Dasar",
        geofenceCategoryName: "Nama Kategori Geofence",
        geofenceName: "Nama Geofence",
        farmRadius: "Radius Peternakan",
        radiusInfo: "Menentukan jarak dari titik pusat ke tepi luar area melingkar.",
        radiusUnitInfo: "Mengacu pada jumlah standar yang digunakan sebagai dasar pengukuran.",
        locationDisabledMessage:
          "Lokasi Anda dinonaktifkan. Harap cari lokasi Anda dari menu kiri.",
        yourDistanceIs: "Jarak Anda adalah",
        activities: "Aktivitas",
        "search": "Cari",
        "selectCountry": "Pilih Negara",
        "filterByFarmName": "Filter Berdasarkan Nama Peternakan",
        "filterByCropType": "Filter Berdasarkan Tipe Tanaman",
        "filterByStartDate": "Filter Berdasarkan Tanggal Mulai",
        "download": "Unduh",
        "of": "dari",
        "previousPage": "Halaman Sebelumnya",
        "nextPage": "Halaman Berikutnya",
        "view": "Lihat",
        "activityDetails": "Detail Aktivitas",
        "activity": "Aktivitas",
        "cropType": "Tipe Tanaman",
        "startDate": "Tanggal Mulai",
        "endDate": "Tanggal Akhir",
        "description": "Deskripsi",
        "close": "Tutup",
        "farmActivities": "Aktivitas Peternakan",
        "listView": "Tampilan Daftar",
        "calendarView": "Tampilan Kalender",
        "scheduledActivities": "Aktivitas Terjadwal",
        "completedActivities": "Aktivitas Selesai",
        deforestationReports: "Laporan Deforestasi",
    
         "organic": "Organik",
      "conventional": "Konvensional",
    
        regBy: "Didaftarkan oleh",
        regDate: "Tanggal pendaftaran",
         selectFarmToEnableCalendarView: "Silakan pilih pertanian untuk mengaktifkan tampilan kalender",
        noFarm: "Tidak ada pertanian yang terdaftar.",
        noFarmDescription: "Silakan klik tombol di bawah ini untuk memulai.",
        searchFarmName: "Cari nama kebun",
    
      },

      farm_upload_validation: {
        Farm_Upload_Validation: "Validasi Unggah Pertanian",
        Bulk_Upload_Field_Validation: "Validasi Bidang Unggah Massal",
        Go_Back: "Kembali",
        Input_Field: "Bidang Masukan",
        Validation_Message: "Pesan Validasi",
        Description: "Deskripsi",
        Action: "Aksi",
        Validate: "Validasi",
        Farm_Name: "Nama Pertanian",
        Farm_Registration_ID: "ID Registrasi Pertanian",
        Farmer_First_Name: "Nama Depan Petani",
        Farmer_Last_Name: "Nama Belakang Petani",
        Farmer_Registration_ID: "ID Registrasi Petani",
        User_Email_Address: "Alamat Email Pengguna",
        Shared_Access_With: "Berbagi Akses Dengan",
        Ownership_Type: "Jenis Kepemilikan",
        Goal_s: "Tujuan",
        Production_Type: "Jenis Produksi",
        Certifications: "Sertifikasi",
        Total_Farm_Size: "Ukuran Total Pertanian (misalnya, 50 hektar atau 20 hektar)",
        Farm_Address: "Alamat Pertanian",
        Farm_GPS_Coordinates: "Koordinat GPS Pertanian (misalnya, 40.7128, -74.0060)",
        Country: "Negara",
        Province_State: "Provinsi/Negara Bagian",
        Village_Town_City: "Desa/Kota",
        Farm_Geofence: "Geofence Pertanian (Poligon atau Lingkaran)",
        Helper_Messages: {
          Farm_Name: {
            Description: "Nama resmi pertanian yang terdaftar di otoritas atau dikenal secara publik.",
            Usage: "Nama ini digunakan untuk identifikasi dan branding."
          },
          Farm_Registration_ID: {
            Description: "Pengidentifikasi unik untuk registrasi pertanian.",
            Assignment: "Diberikan oleh badan pemerintah atau pertanian."
          },
          Farmer_First_Name: {
            Description: "Nama depan petani yang memiliki atau mengoperasikan pertanian.",
            Usage: "Ini digunakan untuk identifikasi pribadi dan dokumentasi hukum.",
            Instructions_1: "Masukkan nama depan petani.",
            Instructions_2: "Hindari singkatan, angka, atau karakter khusus.",
            Instructions_3: "Jika dibiarkan kosong, sistem akan menghasilkan 'Tidak Diketahui' sebagai nama depan."
          },
          Farmer_Last_Name: {
            Description: "Nama belakang (nama keluarga) petani.",
            Usage: "Ini digunakan untuk identifikasi pribadi dan dokumentasi hukum.",
            Instructions_1: "Masukkan nama belakang petani.",
            Instructions_2: "Hindari singkatan, angka, atau karakter khusus.",
            Instructions_3: "Periksa bahwa nama belakang sudah termasuk dan diformat dengan benar.",
            Instructions_4: "Jika dibiarkan kosong, sistem akan menghasilkan 'Tidak Diketahui' sebagai nama belakang."
          },
          Farmer_Registration_ID: {
            Description: "Pengidentifikasi unik untuk registrasi petani.",
            Assignment: "Biasanya diberikan oleh badan regulasi atau pertanian.",
            Usage: "ID ini digunakan untuk registrasi formal dan kepatuhan.",
            Instructions_1: "Masukkan ID Registrasi Petani untuk menghindari duplikasi.",
            Instructions_2: "Pastikan itu unik dan diformat dengan benar.",
            Instructions_3: "Jika dibiarkan kosong, sistem akan meminta Anda untuk menyediakannya untuk mencegah pembuatan entri duplikat (tidak wajib)."
          },
          User_Email_Address: {
            Description: "Ini adalah email dari pengguna yang akan ditugaskan ke pertanian atau akan memiliki akses utama ke pertanian.",
            Context: "Ini bisa berupa petani atau teknisi.",
            Usage: "Email ini digunakan untuk komunikasi, pemberitahuan, dan manajemen akun.",
            Instructions_1: "Masukkan email yang valid (misalnya, contoh@domain.com).",
            Instructions_2: "Periksa kesalahan ketik dan spasi.",
            Instructions_3: "Verifikasi format email sudah benar.",
            Instructions_4: "Jika dibiarkan kosong, sistem harus meminta pengguna untuk menyediakan email yang valid (tidak wajib)."
          },
          Shared_Access_With: {
            Description: "Menentukan individu atau entitas dengan siapa akses ke data pertanian dibagikan.",
            Usage: "Memungkinkan kolaborasi yang terkontrol berdasarkan peran dan tanggung jawab."
          },
          Ownership_Type: {
            Description: "Menunjukkan jenis kepemilikan pertanian.",
            Examples: "Contoh termasuk individu, kemitraan, atau korporasi.",
            Usage: "Ini untuk tujuan hukum dan administratif."
          },
          Goal_s: {
            Description: "Menggambarkan tujuan utama pertanian."
          },
          Production_Type: {
            Description: "Menunjukkan aktivitas pertanian utama dari pertanian, seperti organik atau konvensional."
          },
          Certifications: {
            Description: "Pilih sertifikasi yang terkait dengan pertanian, seperti sertifikasi organik, perdagangan adil, atau GAP."
          },
          Total_Farm_Size: {
            Description: "Luas total pertanian (hektar atau hektar). Digunakan untuk perencanaan sumber daya, pelaporan regulasi, dan analisis pasar."
          },
          Farm_Address: {
            Description: "Masukkan alamat lengkap pertanian, termasuk alamat jalan, kota, negara bagian, dan kode pos. Digunakan untuk identifikasi lokasi dan pengiriman layanan."
          },
          Farm_GPS_Coordinates: {
            Description: "Koordinat geografis (lintang dan bujur) dari lokasi pertanian. Membantu dalam menemukan pertanian di peta."
          },
          Country: {
            Description: "Negara tempat pertanian berada."
          },
          Province_State: {
            Description: "Provinsi atau negara bagian tempat pertanian berada. Opsi tergantung pada negara yang dipilih."
          },
          Village_Town_City: {
            Description: "Desa, kota, atau kota tempat pertanian berada."
          },
          Farm_Geofence: {
            Description: "Pemetaan geofence dari pertanian mencakup batas-batas pertanian di peta. Menentukan batas pertanian menggunakan geofence (poligon atau lingkaran)."
          }
        },
        validation: {
          farmNameRequired: "Nama pertanian diperlukan",
          farmNameMaxLength: "Nama pertanian harus kurang dari 50 karakter",
          farmNameExists: "Nama pertanian sudah ada",
          registrationIDRequired: "ID registrasi diperlukan",
          registrationIDMaxLength: "ID registrasi harus kurang dari 20 karakter",
          firstNameRequired: "Nama depan petani diperlukan",
          firstNameLettersOnly: "Nama depan harus hanya berisi huruf",
          lastNameRequired: "Nama belakang petani diperlukan",
          lastNameLettersOnly: "Nama belakang harus hanya berisi huruf",
          emailRequired: "Email diperlukan",
          emailValid: "Masukkan email yang valid (misalnya, contoh@domain.com)",
          emailNoSpaces: "Email tidak boleh mengandung spasi",
          sharedAccessWithRequired: "Silakan pilih setidaknya satu entitas atau biarkan kosong",
          ownershipTypeRequired: 'Jenis kepemilikan diperlukan atau akan default ke "Tidak Diketahui"',
          farmGoalsMaxLength: "Tujuan pertanian harus kurang dari 500 karakter",
          productionTypeRequired: "Silakan pilih jenis produksi atau biarkan kosong",
          certificationsRequired: "Silakan pilih setidaknya satu entitas atau biarkan kosong",
          farmSizePositive: "Ukuran pertanian harus berupa nilai numerik positif",
          farmSizeUnit: "Tentukan unit (misalnya, 50 hektar atau 20 hektar)",
          farmAddressFormat: "Alamat tidak valid. Format: Jalan, Kota, Negara Bagian, Kode Pos",
          farmGPSCoordinatesFormat: "Koordinat GPS tidak valid. Format: Lintang, Bujur (misalnya, 40.7128, -74.0060)",
          countryRequired: "Negara diperlukan",
          countryLettersOnly: "Nama negara harus hanya berisi huruf",
          provinceStateRequired: "Provinsi/Negara Bagian diperlukan",
          provinceStateLettersOnly: "Provinsi/Negara Bagian harus hanya berisi huruf",
          villageTownCityRequired: "Desa/Kota diperlukan",
          villageTownCityLettersOnly: "Desa/Kota harus hanya berisi huruf",
          farmGeofencePolygon: "Titik poligon tidak valid. Format: Pasangan Lintang, Bujur",
          farmGeofenceCircle: "Geofence tidak valid. Format: Lintang, Bujur Pusat; Area dalam hektar"
        }
      },
      
}